import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { Analytics } from "@vercel/analytics/react";
import "./lib/mixpanel";

// Disable lazy loading for all images in the application
const imgElements = document.querySelectorAll("img");
imgElements.forEach((img) => img.setAttribute("loading", "eager"));

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Analytics />
    </HelmetProvider>
  </React.StrictMode>
);
